import ImmaginiCorrelateContainer from './ImmaginiCorrelateContainer';

export default ImmaginiCorrelateContainer;
